import { Grid, Button, Group, Select, Modal, Title, Checkbox, TextInput, Divider, NumberInput, ActionIcon, Stack, Text, Chip } from '@mantine/core';
import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../../context/context';
import { useForm, isNotEmpty } from '@mantine/form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faCirclePlus, faCircleMinus, faTruck } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import '@mantine/dates/styles.css';
import { showNotification } from '@mantine/notifications';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
const camiones = [{ ruta: 'CDGLHR', camion: '6202' }, { ruta: 'CDGAMS', camion: '6067' }, { ruta: 'CDGBCN', camion: '6124' }, { ruta: 'CDGMAD', camion: '6068' }, { ruta: 'CDGMUC', camion: '6206' }, { ruta: 'CDGFRA', camion: '6201' }, { ruta: 'CDGTLS', camion: '6065' }, { ruta: 'CDGLYS', camion: '6204' }, { ruta: 'AMSLHR', camion: '6064' }, { ruta: 'AMSCDG', camion: '6058' }, { ruta: 'AMSMAD', camion: '6063' }, { ruta: 'AMSFRA', camion: '6260' }, { ruta: 'AMSMUC', camion: '6060' }, { ruta: 'MADAGP', camion: '6053' }, { ruta: 'MADALC', camion: '6074' }, { ruta: 'MADBCN', camion: '6073' }, { ruta: 'MADBIO', camion: '6075' }, { ruta: 'MADSVQ', camion: '6954' }, { ruta: 'MADVLC', camion: '6076' }, { ruta: 'MADZAZ', camion: '6955' }, { ruta: 'MADAMS', camion: '6078' }, { ruta: 'MADBRU', camion: '6056' }, { ruta: 'MADCDG', camion: '6077' }, { ruta: 'MADFRA', camion: '6957' }, { ruta: 'MADLIS', camion: '6958' }, { ruta: 'MADMXP', camion: '6959' }, { ruta: 'MADOPO', camion: '6960' }, { ruta: 'MADPRG', camion: '6961' }, { ruta: 'MADVIE', camion: '6962' }, { ruta: 'MADWAW', camion: '6963' }, { ruta: 'LHRAMS', camion: '6070' }, { ruta: 'LHRCDG', camion: '6071' }, { ruta: 'LHRFRA', camion: '6030' }, { ruta: 'LHRMAD', camion: '6072' }, { ruta: 'FCOAOI', camion: '6154' }, { ruta: 'FCOBLQ', camion: '6155' }, { ruta: 'FCOBLQ', camion: '6156' }, { ruta: 'FCOFLR', camion: '6157' }, { ruta: 'FCOPSA', camion: '6158' }, { ruta: 'FCOGOA', camion: '6159' }, { ruta: 'FCOMXP', camion: '6160' }, { ruta: 'FCOVRN', camion: '6163' }, { ruta: 'FCONAP', camion: '6164' }, { ruta: 'FCONAP', camion: '6165' }, { ruta: 'FCOVCE', camion: '6166' }, { ruta: 'FCOVCE', camion: '6167' }, { ruta: 'FCOAMS', camion: '6168' }, { ruta: 'FCOCDG', camion: '6169' }, { ruta: 'FCOBRU', camion: '6170' }, { ruta: 'FCOLGG', camion: '6171' }, { ruta: 'FCOMST', camion: '6172' }, { ruta: 'FCOLUX', camion: '6173' }, { ruta: 'FCOFRA', camion: '6174' }, { ruta: 'FCOMUC', camion: '6175' }, { ruta: 'FCOZRH', camion: '6176' }, { ruta: 'FCOMAD', camion: '6177' }, { ruta: 'FCOLHR', camion: '6178' }, { ruta: 'GRUVCP', camion: '6039' }, { ruta: 'GRUPOA', camion: '6037' }, { ruta: 'GRUCWB', camion: '6045' }, { ruta: 'GRUGIG', camion: '6005' }, { ruta: 'GRUCNF', camion: '6038' }, { ruta: 'GRUFLN', camion: '6046' }, { ruta: 'EZEGRU', camion: '16' }, { ruta: 'EZESCL', camion: '539' }, { ruta: 'EZEVCP', camion: '417' }, { ruta: 'EZEVCP', camion: '415' }, { ruta: 'EZEVCP', camion: '413' }, { ruta: 'BOGLIM', camion: '321' }, { ruta: 'SCLLIM', camion: '274' }, { ruta: 'SCLEZE', camion: '416' }, { ruta: 'SCLEZE', camion: '414' }, { ruta: 'SCLEZE', camion: '410' }, { ruta: 'SCLEZE', camion: '412' }, { ruta: 'LHRGLA', camion: '6287' }]

const FormRecord = ({ id, reloadTable, dataCarriers, dataCS, dataCodeDesviation, setIsVisible, fechas }) => {

    const appcontext = useContext(AppContext);
    const [title, setTitle] = useState('')

    useEffect(() => {
        if (id != '' && appcontext.openedFNR) {
            getDataFromId(id);
            setTitle('Editar registro');
        } else {
            setTitle('Nuevo registro');
            resetform();
        }
    }, [appcontext.openedFNR]);

    //HUBS
    const [inputsHubs, setInputsHubs] = useState(['HUB DEP', 'HUB']);
    const [formDataHubs, setFormDataHubs] = useState({ 0: '', 1: '' });

    //Carriers
    const [inputsCarrier, setInputsCarrier] = useState(['Carrier']);
    const [formDataCarrier, setFormDatacarrier] = useState({ 0: '' });

    //Vuelos
    const [formDataVuelos, setFormDataVuelos] = useState([{ 0: '', 1: '', 2: null, 3: false, 4: '', 5: '' }]);

    //cs
    const [inputsCS, setInputsCS] = useState(['Conexion Status']);
    const [formDataCS, setFormDataCS] = useState([null]);

    //form inputs
    const [service, setService] = useState('');
    const [completeDocuments, setCompleteDocuments] = useState('');
    const [exceed1M, setExceed1M] = useState('');
    const [t1, setT1] = useState('');
    const [codeDesviation, setCodeDesviation] = useState('');
    const [opt2, setOpt2] = useState(false);

    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            fechaVuelo: new Date(),
            ejecutivo: sessionStorage.getItem("user"),
            prefix: 139,
            awb: '',
            qty: '',
            weigth: '',

            vol3: '',
            volkg: '',
            tons: '',
            description: '',
            shc: '',
            dims: '',

            origin: '',
            destination: '',
            forwarder: '',
            opt: '',
            interline: '',
            prealertdate: null,
            remarks: '',
            fab: '',
            prioridades: ''
        },

        validate: {
            fechaVuelo: isNotEmpty('Debes ingresar una fecha de vuelo'),
            ejecutivo: isNotEmpty('Debes ingresar un ejecutivo'),
            prefix: isNotEmpty('Debes ingresar un número prefijo'),
            awb: isNotEmpty('Debes ingresar un número awb'),
            qty: isNotEmpty('Debes ingresar un valor'),
            weigth: isNotEmpty('Debes ingresar un valor'),
        },
    });

    //Hubs
    const addInputFieldHub = () => {
        setInputsHubs([...inputsHubs, `HUB ${inputsHubs.length}`]);
    };
    const handleInputChangeHub = (index, event) => {
        const newFormData = { ...formDataHubs, [index]: event.target.value };
        setFormDataHubs(newFormData);
    };
    const removeInputFieldHub = () => {
        if (inputsHubs.length > 1) {
            const newInputs = [...inputsHubs];
            newInputs.pop(); // Remove the last element
            setInputsHubs(newInputs);
            const newFormData = { ...formDataHubs };
            delete newFormData[inputsHubs.length - 1]; // Remove the last form data entry
            setFormDataHubs(newFormData);
        } else {
            showNotification({
                title: 'Error!',
                message: 'No se pueden eliminar mas HUBS',
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
    };

    //Carriers
    const addInputFieldCarrier = () => {
        setInputsCarrier([...inputsCarrier, `Carrier ${inputsCarrier.length}`]);
    };
    const handleInputChangeCarrier = (index, event) => {
        const newFormData = { ...formDataCarrier, [index]: event };
        setFormDatacarrier(newFormData);
    };
    const removeInputFieldCarrier = () => {
        if (inputsCarrier.length > 1) {
            const newInputs = [...inputsCarrier];
            newInputs.pop(); // Remove the last element
            setInputsCarrier(newInputs);
            const newFormData = { ...formDataCarrier };
            delete newFormData[inputsCarrier.length - 1]; // Remove the last form data entry
            setFormDataHubs(newFormData);
        } else {
            showNotification({
                title: 'Error!',
                message: 'No se pueden eliminar mas Carriers',
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
    };

    //Vuelos
    const addInputFieldVuelo = () => {
        setFormDataVuelos([...formDataVuelos, { 0: '', 1: '', 2: null, 3: false, 4: '', 5: '' }]);
    };
    const handleInputChangeVuelo = (index, event, pos) => {
        const obj = formDataVuelos[index];
        obj[pos] = (pos == 2 || pos == 3) ? event : event.target.value;
        const newFormData = [...formDataVuelos];
        newFormData[index] = obj;
        setFormDataVuelos(newFormData);
    }
    const removeInputFieldVuelo = () => {
        if (formDataVuelos.length > 1) {
            const newData = [...formDataVuelos]
            newData.pop(); // Remove the last element
            setFormDataVuelos(newData);
        } else {
            showNotification({
                title: 'Error!',
                message: 'No se pueden eliminar mas Vuelos',
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
    };
    const handleSearchCamion = (index) => {
        const result = camiones.filter(item => item.ruta.toString().toLowerCase() == formDataVuelos[index][0].toLocaleLowerCase())
        if (result.length == 0) {
            showNotification({
                title: 'Error!',
                message: "No se encontro camion, valida que la ruta este escrita sin espacion ni guiones ejemplo:'CDGLHR'",
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        } else {
            const obj = formDataVuelos[index];
            obj[1] = result[0].camion;
            const newFormData = [...formDataVuelos];
            newFormData[index] = obj;
            setFormDataVuelos(newFormData);
        }

    }

    //CS
    const addInputFieldCS = () => {
        setInputsCS([...inputsCS, `Conexion Status ${inputsCS.length}`]);
    };
    const handleInputChangeCS = (index, event) => {
        const newFormData = { ...formDataCS, [index]: event };
        setFormDataCS(newFormData);
    };
    const removeInputFieldCS = () => {
        if (inputsCS.length > 1) {
            const newInputs = [...inputsCS];
            newInputs.pop(); // Remove the last element
            setInputsCS(newInputs);
            const newFormData = { ...formDataCS };
            delete newFormData[inputsCS.length - 1]; // Remove the last form data entry
            setFormDataCS(newFormData);
        } else {
            showNotification({
                title: 'Error!',
                message: 'No se pueden eliminar mas Conexion Status',
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
    };
    

    const getSkyInfoInterlineales = async () => {
        try {
            setIsVisible(true);
            const response = await axios.post(process.env.REACT_APP_API_URL_DE + '/api/interlineales/interskyinfo', { "PREFIX": form.getValues().prefix, "AWB": form.getValues().awb }, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                }
            });
            console.log(response);
            if(response.data.status!="OK")
                throw new Error("No se pudo consultar la guia");

            form.setValues({
                destination: response.data.message[0].destinoform,
                origin: response.data.message[0].origenform,
                qty: response.data.message[0].piezasform,
                weigth: response.data.message[0].weightform
            });
            const vuelos = [];
            response.data.message[0].vuelos.forEach(element => {
                const obj = {};
                obj[0] = element[0];
                obj[1] = element[1];
                const [day, month, year] = element[2].split('/').map(Number);
                obj[2] = new Date(year, month - 1, day);
                obj[3] = element[3];
                obj[4] = element[4];
                obj[5] = element[5];
                vuelos.push(obj);
            });
            setFormDataVuelos(vuelos);

        } catch (err) {
            showNotification({
                title: 'Error!',
                message: err.response?.data?.error ? err.response.data.error : err.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
        finally {
            setIsVisible(false);
        }
    }

    const getDataFromId = async (id) => {
        try {
            setIsVisible(true);            
            const response = await axios.post(process.env.REACT_APP_API_URL_DE + '/api/interlineales/getAllInterlineInfo', { "id": id }, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                }
            });
            form.setValues({
                fechaVuelo: new Date(response.data.fechaVuelo),
                ejecutivo: response.data.ejecutivo,
                prefix: response.data.prefix,
                awb: response.data.awb,
                qty: response.data.qty,
                weigth: response.data.weigth,
                vol3: response.data.vol3,
                volkg: '',
                tons: '',
                description: response.data.description,
                shc: response.data.shc,
                dims: response.data.dims,
                origin: response.data.origin,
                destination: response.data.destination,
                forwarder: response.data.forwarder,
                opt: response.data.opt,
                interline: response.data.interline,
                prealertdate: response.data.prealertdate == null ? null : new Date(response.data.prealertdate),
                remarks: response.data.remarks,
                fab: response.data.fab,
                prioridades: response.data.prioridades
            });
            handleCalculateVolumen();
            setService(response.data.service == '' ? null : response.data.service);
            var arr = [];

            Object.keys(response.data.hubs).forEach(key => {
                if (key == 0) {
                    arr.push("HUB DEP")
                } else {
                    arr.push("HUB " + key)
                }
            });
            setInputsHubs(arr);
            setFormDataHubs(response.data.hubs);
            arr = [];
            Object.keys(response.data.carriers).forEach(key => {
                if (key == 0) {
                    arr.push("Carrier")
                } else {
                    arr.push("Carrier " + key)
                }
            });
            setInputsCarrier(arr);
            setFormDatacarrier(response.data.carriers);
            arr = [];
            response.data.vuelos.forEach(element => {
                const obj = {};
                obj[0] = element[0];
                obj[1] = element[1];
                obj[2] = element[2] == null ? null : new Date(element[2]);
                obj[3] = element[3];
                obj[4] = element[4];
                obj[5] = element[5];
                arr.push(obj);
            });
            setFormDataVuelos(arr);
            arr = [];
            Object.keys(response.data.conexionStatus).forEach(key => {
                if (key == 0) {
                    arr.push("Conexion Status")
                } else {
                    arr.push("Conexion Status " + key)
                }
            });
            setInputsCS(arr);
            setFormDataCS(response.data.conexionStatus);

            setCompleteDocuments(response.data.completeDocuments);
            setExceed1M(response.data.exceed1m);
            setT1(response.data.t1);
            setCodeDesviation(response.data.codeDesviation);
            setOpt2(response.data.opt_sec);
        } catch (err) {
            showNotification({
                title: 'Error!',
                message: err.response?.data?.error ? err.response.data.error : err.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
        finally {
            setIsVisible(false);
        }
    }


    const handleCalculateVolumen = () => {
        var initval = form.getValues().vol3;
        var volkg = ((initval * 166.670).toFixed(3));
        var tons = ((initval * 166.670) / 1000).toFixed(3);
        form.setValues({
            volkg: volkg,
            tons: tons
        })
    }

    //save result
    const handleSave = async (values) => {
        values.service = service;
        values.hubs = formDataHubs;
        values.carriers = formDataCarrier;
        values.vuelos = formDataVuelos;
        values.conexionStatus = formDataCS;
        values.completeDocuments = completeDocuments;
        values.exceed1m = exceed1M;
        values.t1 = t1;
        values.codeDesviation = codeDesviation;
        values.opt_sec = opt2;
        values.USUARIO_ACTUALIZACION = sessionStorage.getItem("user");
        try {
            setIsVisible(true);
            if (id != '') {
                //actualiza
                values.id = id;
                const response = await axios.put(process.env.REACT_APP_API_URL_DE + '/api/interlineales', values, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                    }
                });
                showNotification({
                    title: 'Listo!',
                    message: 'Registro actualizado con exito',
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#25A661',
                            borderColor: '#25A661',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: false,
                });
                appcontext.setStatusFNR(false);
            } else {
                const response = await axios.post(process.env.REACT_APP_API_URL_DE + '/api/interlineales/InsertOne', values, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Include the Bearer token
                    }
                });
                showNotification({
                    title: 'Listo!',
                    message: 'Registro guardado con exito',
                    color: '#fff',
                    styles: (theme) => ({
                        root: {
                            backgroundColor: '#25A661',
                            borderColor: '#25A661',
                            '&::before': { backgroundColor: theme.white },
                        },
                        title: { color: theme.white },
                        description: { color: theme.white },
                        closeButton: {
                            color: theme.white,
                        },
                    }),
                    autoClose: false,
                });
            }

            if (fechas.length !== 0) {
                reloadTable();
            }

            resetform();
        } catch (err) {
            showNotification({
                title: 'Error!',
                message: err.response.data ? err.response.data.error : err.message,
                color: '#fff',
                styles: (theme) => ({
                    root: {
                        backgroundColor: '#E93F19',
                        borderColor: 'E93F19',
                        '&::before': { backgroundColor: theme.white },
                    },
                    title: { color: theme.white },
                    description: { color: theme.white },
                    closeButton: {
                        color: theme.white,
                    },
                }),
                autoClose: false,
            })
        }
        finally {
            setIsVisible(false);
        }
    }

    const resetform = () => {
        form.reset();
        //hubs
        setInputsHubs(['HUB DEP', 'HUB']);
        setFormDataHubs({ 0: '', 1: '' });
        //carriers
        setInputsCarrier(['Carrier']);
        setFormDatacarrier({ 0: '' });
        //Vuelos
        setFormDataVuelos([{ 0: '', 1: '', 2: null, 3: false, 4: '', 5: '' }]);
        //CS
        setInputsCS(['Conexion Status']);
        setFormDataCS([null]);

        setService(null);
        setCompleteDocuments(null);
        setExceed1M(null);
        setT1(null);
        setCodeDesviation(null);
        setOpt2(false);
    }

    return (
        <Modal
            opened={appcontext.openedFNR}
            onClose={() => appcontext.setStatusFNR(false)}
            title={title}
            fullScreen
            radius={0}
            transitionProps={{ transition: 'fade', duration: 200 }}
        >
            <form onSubmit={form.onSubmit((values) => { handleSave(values) })}>
                <Grid justify="center" align="center">
                    <Grid.Col span={12}>
                        <Group>
                            <Title order={5}>Datos Generales</Title>
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <DatesProvider settings={{ locale: 'es' }}>
                            <DatePickerInput
                                defaultValue={new Date()}
                                valueFormat="DD/MM/YYYY"
                                label="Fecha Vuelo"
                                placeholder="Fecha Vuelo"
                                key={form.key('fechaVuelo')}
                                {...form.getInputProps('fechaVuelo')}
                            />
                        </DatesProvider>
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="Ejecutivo"
                            placeholder="Ejecutivo"
                            
                            key={form.key('ejecutivo')}
                            {...form.getInputProps('ejecutivo')}
                            disabled
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <NumberInput
                            label="Prefix"
                            placeholder="Prefix"
                            
                            key={form.key('prefix')}
                            {...form.getInputProps('prefix')}
                            disabled
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <NumberInput
                            label="AWB"
                            placeholder="AWB"
                            withAsterisk
                            key={form.key('awb')}
                            {...form.getInputProps('awb')}
                            leftSection={<ActionIcon variant='outline' onClick={getSkyInfoInterlineales}><FontAwesomeIcon icon={faMagnifyingGlass} size='sm' /></ActionIcon>}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <NumberInput
                            label="QTY"
                            placeholder="qty"
                            withAsterisk
                            key={form.key('qty')}
                            {...form.getInputProps('qty')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <NumberInput
                            label="Weigth"
                            placeholder="Weigth"
                            withAsterisk
                            key={form.key('weigth')}
                            {...form.getInputProps('weigth')}
                        />
                    </Grid.Col>

                    {/*Row 2*/}
                    <Grid.Col span={2}>
                        <NumberInput
                            label="Vol3"
                            placeholder="vol3"
                            onBlurCapture={handleCalculateVolumen}
                            key={form.key('vol3')}
                            {...form.getInputProps('vol3')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="VolKg"
                            placeholder="VolKg"
                            readOnly
                            key={form.key('volkg')}
                            {...form.getInputProps('volkg')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="Tons"
                            placeholder="Tons"
                            readOnly
                            key={form.key('tons')}
                            {...form.getInputProps('tons')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="Description"
                            placeholder="Description"
                            key={form.key('description')}
                            {...form.getInputProps('description')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="SHC"
                            placeholder="SHC"
                            key={form.key('shc')}
                            {...form.getInputProps('shc')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="DIMS"
                            placeholder="DIMS"
                            key={form.key('dims')}
                            {...form.getInputProps('dims')}
                        />
                    </Grid.Col>

                    {/* Row 3 */}
                    <Grid.Col span={2}>
                        <TextInput
                            label="ORIGIN"
                            placeholder="ORIGIN"
                            key={form.key('origin')}
                            {...form.getInputProps('origin')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="DESTINATION"
                            placeholder="DESTINATION"
                            key={form.key('destination')}
                            {...form.getInputProps('destination')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="FORWARDER"
                            placeholder="FORWARDER"
                            key={form.key('forwarder')}
                            {...form.getInputProps('forwarder')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Select label="Tipo de servicio" placeholder='Selecciona una opción' data={['N/A', 'Exportación', 'Importación']} value={service} onChange={setService} />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="OPT_M7_6R"
                            placeholder="OPT_M7_6R"
                            key={form.key('opt')}
                            {...form.getInputProps('opt')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="INTERLINE CONNECTION"
                            placeholder="INTERLINE CONNECTION"
                            key={form.key('interline')}
                            {...form.getInputProps('interline')}
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Divider size="sm" />
                    </Grid.Col>
                    {/* Row 4 */}
                    <Grid.Col span={12}>
                        <Group>
                            <Title order={5}>Hubs</Title><ActionIcon variant='default' onClick={addInputFieldHub} ><FontAwesomeIcon icon={faCirclePlus} size='lg' /></ActionIcon><ActionIcon variant='default' onClick={removeInputFieldHub} ><FontAwesomeIcon icon={faCircleMinus} size='lg' /></ActionIcon>
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Group>
                            {inputsHubs.map((inputKey, index) => (
                                <Grid.Col span={2} key={index}>
                                    <TextInput
                                        label={inputKey}
                                        placeholder={inputKey}
                                        value={formDataHubs[index] || ''}
                                        onChange={(event) => handleInputChangeHub(index, event)}
                                    />
                                </Grid.Col>
                            ))}
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Divider size="sm" />
                    </Grid.Col>
                    {/* Row 5 */}
                    <Grid.Col span={12}>
                        <Group>
                            <Title order={5}>Carriers</Title><ActionIcon variant='default' onClick={addInputFieldCarrier} ><FontAwesomeIcon icon={faCirclePlus} size='lg' /></ActionIcon><ActionIcon variant='default' onClick={removeInputFieldCarrier} ><FontAwesomeIcon icon={faCircleMinus} size='lg' /></ActionIcon>
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Group>
                            {inputsCarrier.map((inputKey, index) => (
                                <Grid.Col span={2} key={'Carrier' + index}>
                                    <Select label={inputKey} placeholder='Selecciona una opción' data={dataCarriers} value={formDataCarrier[index] || ''} onChange={(event) => handleInputChangeCarrier(index, event)} />
                                </Grid.Col>
                            ))}
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Divider size="sm" />
                    </Grid.Col>
                    {/* Row 6 */}
                    <Grid.Col span={12}>
                        <Group>
                            <Title order={5}>Vuelos</Title><ActionIcon variant='default' onClick={addInputFieldVuelo} ><FontAwesomeIcon icon={faCirclePlus} size='lg' /></ActionIcon><ActionIcon variant='default' onClick={removeInputFieldVuelo} ><FontAwesomeIcon icon={faCircleMinus} size='lg' /></ActionIcon>
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        {formDataVuelos.map((inputKey, index) => (
                            <Group key={"vuelo" + index} justify='center'>
                                <Grid.Col span={2}>
                                    <TextInput
                                        label={index == 0 ? "Ruta" : "Ruta " + (index + 1)}
                                        placeholder={index == 0 ? "Ruta" : "Ruta " + (index + 1)}
                                        value={formDataVuelos[index][0] || ''}
                                        onChange={(event) => handleInputChangeVuelo(index, event, 0)}
                                        rightSection={<ActionIcon variant='outline' onClick={() => handleSearchCamion(index)}><FontAwesomeIcon icon={faTruck} size='sm' /></ActionIcon>}
                                    />
                                </Grid.Col>
                                <Grid.Col span={2}>
                                    <TextInput
                                        label={index == 0 ? "Vuelo" : "Vuelo " + (index + 1)}
                                        placeholder={index == 0 ? "Vuelo" : "Vuelo " + (index + 1)}
                                        value={formDataVuelos[index][1]}
                                        onChange={(event) => handleInputChangeVuelo(index, event, 1)}
                                    />
                                </Grid.Col>
                                <Grid.Col span={2}>

                                    <DatesProvider settings={{ locale: 'es' }}>
                                        <DatePickerInput
                                            clearable
                                            valueFormat="DD/MM/YYYY"
                                            label={index == 0 ? "Fecha Vuelo" : "Fecha Vuelo " + (index + 1)}
                                            placeholder='Fecha Pendiente'
                                            value={formDataVuelos[index][2]}
                                            onChange={(value) => handleInputChangeVuelo(index, value, 2)}
                                        />
                                    </DatesProvider>


                                </Grid.Col>
                                <Grid.Col span={1}>
                                    <Stack gap="xs" align='center'>
                                        <Text>Fecha Tentativa</Text>
                                        <Checkbox checked={formDataVuelos[index][3]} onChange={(event) => handleInputChangeVuelo(index, event.currentTarget.checked, 3)}></Checkbox>
                                    </Stack>
                                </Grid.Col>
                                <Grid.Col span={2}>
                                    <TextInput
                                        label={index == 0 ? "ETD" : "ETD " + (index + 1)}
                                        placeholder={index == 0 ? "ETD" : "ETD " + (index + 1)}
                                        value={formDataVuelos[index][4]}
                                        onChange={(event) => handleInputChangeVuelo(index, event, 4)}
                                    />
                                </Grid.Col>
                                <Grid.Col span={2}>
                                    <TextInput
                                        label={index == 0 ? "ETA" : "ETA " + (index + 1)}
                                        placeholder={index == 0 ? "ETA" : "ETA " + (index + 1)}
                                        value={formDataVuelos[index][5]}
                                        onChange={(event) => handleInputChangeVuelo(index, event, 5)}
                                    />
                                </Grid.Col>

                            </Group>
                        ))}
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Divider size="sm" />
                    </Grid.Col>
                    {/* Row 7 */}
                    <Grid.Col span={12}>
                        <Group>
                            <Title order={5}>Conexion Status</Title><ActionIcon variant='default' onClick={addInputFieldCS} ><FontAwesomeIcon icon={faCirclePlus} size='lg' /></ActionIcon><ActionIcon variant='default' onClick={removeInputFieldCS} ><FontAwesomeIcon icon={faCircleMinus} size='lg' /></ActionIcon>
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Group>
                            {inputsCS.map((inputKey, index) => (
                                <Grid.Col span={2} key={'CS' + index}>
                                    <Select label={inputKey} placeholder='Selecciona una opción' data={dataCS} value={formDataCS[index] || ''} onChange={(event) => handleInputChangeCS(index, event)} />
                                </Grid.Col>
                            ))}
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Divider size="sm" />
                    </Grid.Col>
                    {/*Row 8 Datos complementarios*/}

                    <Grid.Col span={12}>
                        <Group>
                            <Title order={5}>Datos complementarios</Title>
                        </Group>
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <DatesProvider settings={{ locale: 'es' }}>
                            <DatePickerInput
                                valueFormat="DD/MM/YYYY"
                                clearable
                                label="Prealert Date"
                                placeholder="Prealert Date"
                                key={form.key('prealertdate')}
                                {...form.getInputProps('prealertdate')}
                            />
                        </DatesProvider>
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="Remarks"
                            placeholder="Remarks"
                            key={form.key('remarks')}
                            {...form.getInputProps('remarks')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Select label="Complete Documents" placeholder='Selecciona una opción' data={['N/A', 'YES', 'NO']} value={completeDocuments} onChange={setCompleteDocuments} />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Select label="Exceed 1M" placeholder='Selecciona una opción' data={['N/A', 'YES', 'NO']} value={exceed1M} onChange={setExceed1M} />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Select label="T1 Status" placeholder='Selecciona una opción' data={['N/A', 'NOT CONFIRMED', 'CONFIRMED']} value={t1} onChange={setT1} />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Select label="Code Desviation" placeholder='Selecciona una opción' data={dataCodeDesviation} value={codeDesviation} onChange={setCodeDesviation} />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="FAB"
                            placeholder="FAB"
                            key={form.key('fab')}
                            {...form.getInputProps('fab')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <TextInput
                            label="PRIORIDADES"
                            placeholder="PRIORIDADES"
                            key={form.key('prioridades')}
                            {...form.getInputProps('prioridades')}
                        />
                    </Grid.Col>
                    <Grid.Col span={2}>
                        <Chip checked={opt2} onChange={() => setOpt2((v) => !v)}>OPT</Chip>
                    </Grid.Col>

                </Grid>
                <Group justify="flex-end" mt="md">
                    <Button type="button" variant='outline' onClick={() => appcontext.setStatusFNR(false)}>Cerrar</Button>
                    <Button type="submit">Guardar</Button>
                </Group>
            </form>
        </Modal>
    );
}

export default FormRecord;